module.exports = __webpack_public_path__ + "img/pelmenya_logo_dark.8ace1ef5.svg";